"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOffersFilterContextValue = exports.useOffersFilterContextProvider = void 0;
exports.formatCombinedValues = formatCombinedValues;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const antd_1 = require("antd");
const react_router_1 = require("react-router");
const react_intl_1 = require("react-intl");
const types_1 = require("@src/types");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const offer_1 = require("@src/types/offer");
const get_filters_states_from_pathname_1 = require("@src/helpers/get-filters-states-from-pathname");
const Api = __importStar(require("@src/api"));
const useIsFirstRender_1 = require("@src/hooks/useIsFirstRender");
const use_query_parameters_1 = require("@src/helpers/use-query-parameters");
const roundSalaryToTen_1 = require("@src/helpers/roundSalaryToTen");
const offers_filter_1 = require("./utils/offers-filter");
const OffersFilterContext = react_1.default.createContext({
    typeFiltersSelected: [],
    locationFiltersSelected: [],
    jobAreaFiltersSelected: [],
    searchCompaniesSelected: [],
    searchKeywordsSelected: [],
    setTypeFiltersSelected: () => null,
    setLocationFiltersSelected: () => null,
    setJobAreaFiltersSelected: () => null,
    setSearchCompaniesSelected: () => null,
    setSearchKeywordsSelected: () => null,
    offers: {},
    promotedOffers: [],
    offersFiltersSSR: {},
    areOffersLoading: false,
    areFiltersLoading: false,
    arePromotedOffersLoading: false,
    changePage: () => null,
    setPage: () => null,
    salaryFilter: {},
    setSalaryFilter: () => null,
    getHighestSalary: async () => 0,
    isFilterActive: false,
    highestSalary: 0,
    companies: [],
    highestGlobalSalary: 0,
});
function formatCombinedValues(values) {
    const { companies, keywords, skillTags } = values;
    const kws = (keywords || []).map(itemValue => ({
        value: itemValue,
        label: itemValue,
        key: itemValue,
        group: offer_1.SearchFilterOptionGroup.keyword,
    }));
    const comps = (companies || []).map(({ name: itemName, id: itemId }) => ({
        value: itemId,
        label: itemName,
        key: itemId,
        group: offer_1.SearchFilterOptionGroup.company,
    }));
    const skills = (skillTags || []).map(({ name: itemName, id: itemId }) => ({
        value: itemId,
        label: itemName,
        key: itemId,
        group: offer_1.SearchFilterOptionGroup.skillTag,
    }));
    return [...kws, ...comps, ...skills];
}
const useOffersFilterContextProvider = () => {
    const history = (0, react_router_1.useHistory)();
    const location = (0, react_router_1.useLocation)();
    const params = (0, react_router_1.useParams)();
    const intl = (0, react_intl_1.useIntl)();
    const isFirstRender = (0, useIsFirstRender_1.useIsFirstRender)();
    const { getQueryParams, createQueryParams } = (0, use_query_parameters_1.useQueryParameters)();
    const filterStates = getQueryParams();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const { selectedTypeIds, selectedLocations, selectedJobAreaIds, salaryMin, salaryMax, salaryRate, selectedCompaniesIds, selectedKeywords, } = react_1.default.useMemo(() => (0, offers_filter_1.useConvertFilterStatesTypes)(filterStates), [filterStates]);
    const initPage = (0, get_filters_states_from_pathname_1.getOffersPageFromPathname)(location.pathname);
    const { data: highestSalary } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.highestSalary.key);
    const { data: globalHighestSalary } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.globalHighestSalary.key);
    const { data: companies, refetch: refetchCompanies } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.companies.key, selectedCompaniesIds);
    const [highestGlobalSalary, setHighestGlobalSalary] = react_1.default.useState((0, roundSalaryToTen_1.roundSalary)(globalHighestSalary));
    const [wasHighestSalaryChangedFromHook, setWasHighestSalaryChangedFromHook] = react_1.default.useState(!highestSalary);
    const [page, setPage] = react_1.default.useState(initPage);
    const [typeFiltersSelected, setTypeFiltersSelected] = react_1.default.useState(selectedTypeIds || []);
    const [locationFiltersSelected, setLocationFiltersSelected] = react_1.default.useState(selectedLocations || []);
    const [jobAreaFiltersSelected, setJobAreaFiltersSelected] = react_1.default.useState(selectedJobAreaIds || []);
    const [searchCompaniesSelected, setSearchCompaniesSelected] = react_1.default.useState(
    // this condition handles the case when companies are prefetched and user returns to offers page from different page
    // otherwise prefetched companies would be automatically set to state
    (selectedCompaniesIds && selectedCompaniesIds.length && companies) || []);
    const [searchKeywordsSelected, setSearchKeywordsSelected] = react_1.default.useState(selectedKeywords || []);
    const [salaryFilter, setSalaryFilter] = react_1.default.useState({
        minRange: salaryMin || 0,
        maxRange: salaryMax || (0, roundSalaryToTen_1.roundSalary)(highestSalary),
        highestSalary: (0, roundSalaryToTen_1.roundSalary)(highestSalary),
        rate: salaryRate || null,
    });
    const selectedTypeFilterItemsRef = react_1.default.useRef(typeFiltersSelected);
    const selectedLocationFilterItemsRef = react_1.default.useRef(locationFiltersSelected);
    const selectedJobAreaFiltersSelectedRef = react_1.default.useRef(jobAreaFiltersSelected);
    const searchCompaniesSelectedRef = react_1.default.useRef(searchCompaniesSelected);
    const searchKeywordsSelectedRef = react_1.default.useRef(searchKeywordsSelected);
    const salaryFilterRef = react_1.default.useRef(salaryFilter);
    const isFilterActive = typeFiltersSelected.length !== 0 ||
        locationFiltersSelected.length !== 0 ||
        jobAreaFiltersSelected.length !== 0 ||
        Boolean(salaryFilter.rate) ||
        selectedCompaniesIds.length !== 0 ||
        searchCompaniesSelected.length !== 0 ||
        searchKeywordsSelected.length !== 0;
    const getHighestSalary = async (value) => {
        try {
            const newHighestSalary = await Api.Offers.getHighestSalaryByRate(value || salaryFilter.rate);
            const maxRoundedSalary = (0, roundSalaryToTen_1.roundSalary)(newHighestSalary);
            return maxRoundedSalary;
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            console.error(err);
        }
    };
    const changePage = (newPage) => {
        const pageHasNotChanged = (!parseInt(params.page, 10) && newPage === 1) || parseInt(params.page, 10) === newPage;
        if (pageHasNotChanged) {
            return;
        }
        setPage(newPage);
        const { search: filterQuery } = history.location;
        if (newPage === 1) {
            return history.pushLocalized(`/ponuky${filterQuery}`);
        }
        return history.pushLocalized(`/ponuky/${newPage}${filterQuery}`);
    };
    react_1.default.useEffect(() => {
        if (page !== Number(params.page)) {
            setPage(Number(params.page) || 1);
        }
    }, [params]);
    react_1.default.useEffect(() => {
        const areTypesEqual = (0, lodash_1.isEqual)(selectedTypeFilterItemsRef.current, typeFiltersSelected);
        const areLocationsEqual = (0, lodash_1.isEqual)(locationFiltersSelected, selectedLocationFilterItemsRef.current);
        const areJobAreasEqual = (0, lodash_1.isEqual)(jobAreaFiltersSelected, selectedJobAreaFiltersSelectedRef.current);
        const hasHighestSalaryChanged = salaryFilter.highestSalary !== salaryFilterRef.current.highestSalary;
        const isSalaryFilterEqual = (0, lodash_1.isEqual)(salaryFilter, salaryFilterRef.current);
        const areCompaniesEqual = (0, lodash_1.isEqual)(searchCompaniesSelected, searchCompaniesSelectedRef.current);
        const areKeywordsEqual = (0, lodash_1.isEqual)(searchKeywordsSelected, searchKeywordsSelectedRef.current);
        const hasStateChanged = !areTypesEqual ||
            !areLocationsEqual ||
            !areJobAreasEqual ||
            !isSalaryFilterEqual ||
            !areCompaniesEqual ||
            !areKeywordsEqual;
        if (hasStateChanged && !isFirstRender) {
            if (!wasHighestSalaryChangedFromHook) {
                changePage(1);
            }
            selectedTypeFilterItemsRef.current = typeFiltersSelected;
            selectedLocationFilterItemsRef.current = locationFiltersSelected;
            selectedJobAreaFiltersSelectedRef.current = jobAreaFiltersSelected;
            salaryFilterRef.current = salaryFilter;
            searchCompaniesSelectedRef.current = searchCompaniesSelected;
            searchKeywordsSelectedRef.current = searchKeywordsSelected;
        }
        if (isFilterActive && !isFirstRender && !wasHighestSalaryChangedFromHook) {
            const hasMaximumSetToMaximum = salaryFilter.maxRange === salaryFilter.highestSalary;
            const qs = createQueryParams({
                [types_1.OfferFilterType.type]: typeFiltersSelected.length !== 0 ? typeFiltersSelected : null,
                [types_1.OfferFilterType.location]: locationFiltersSelected.length !== 0 ? locationFiltersSelected : null,
                [types_1.OfferFilterType.jobArea]: jobAreaFiltersSelected.length !== 0 ? jobAreaFiltersSelected : null,
                [types_1.OfferFilterType.salaryMin]: salaryFilter.rate ? salaryFilter.minRange : null,
                [types_1.OfferFilterType.salaryMax]: salaryFilter.rate && !hasMaximumSetToMaximum ? salaryFilter.maxRange : null,
                [types_1.OfferFilterType.salaryRate]: salaryFilter.rate ? salaryFilter.rate : null,
                [types_1.OfferFilterType.searchCompaniesSelected]: searchCompaniesSelected.length !== 0 ? searchCompaniesSelected.map(company => company.id) : null,
                [types_1.OfferFilterType.searchKeywordsSelected]: searchKeywordsSelected.length !== 0 ? searchKeywordsSelected : null,
            });
            if (qs !== location.search.slice(1)) {
                history.push({
                    search: qs,
                });
            }
        }
        if (hasHighestSalaryChanged && wasHighestSalaryChangedFromHook) {
            setWasHighestSalaryChangedFromHook(false);
        }
        if (!isFilterActive && location.search && hasStateChanged) {
            history.push({
                search: '',
            });
        }
    }, [
        typeFiltersSelected,
        locationFiltersSelected,
        jobAreaFiltersSelected,
        salaryFilter,
        searchCompaniesSelected,
        searchKeywordsSelected,
    ]);
    react_1.default.useEffect(() => {
        const areTypesEqual = (0, lodash_1.isEqual)(typeFiltersSelected, selectedTypeIds);
        if (!areTypesEqual) {
            setTypeFiltersSelected(selectedTypeIds);
        }
    }, [selectedTypeIds]);
    react_1.default.useEffect(() => {
        const areLocationsEqual = (0, lodash_1.isEqual)(locationFiltersSelected, selectedLocations);
        if (!areLocationsEqual) {
            setLocationFiltersSelected(selectedLocations);
        }
    }, [selectedLocations]);
    react_1.default.useEffect(() => {
        const areJobAreasEqual = (0, lodash_1.isEqual)(jobAreaFiltersSelected, selectedJobAreaIds);
        if (!areJobAreasEqual) {
            setJobAreaFiltersSelected(selectedJobAreaIds);
        }
    }, [selectedJobAreaIds]);
    react_1.default.useEffect(() => {
        const areKeywordsEqual = (0, lodash_1.isEqual)(searchKeywordsSelected, selectedKeywords);
        if (!areKeywordsEqual) {
            setSearchKeywordsSelected(selectedKeywords);
        }
    }, [selectedKeywords]);
    react_1.default.useEffect(() => {
        let isSubscribed = true;
        const getHighestSalaryByRateAndSetValues = async () => {
            let roundedHighestSalary;
            if (salaryRate) {
                roundedHighestSalary = await getHighestSalary(salaryRate);
            }
            if (!roundedHighestSalary) {
                roundedHighestSalary = (0, roundSalaryToTen_1.roundSalary)(highestSalary);
            }
            const isSalaryMaxEqual = salaryMax
                ? salaryFilter.maxRange === salaryMax
                : salaryFilter.maxRange === roundedHighestSalary;
            const isSalaryMinEqual = (0, lodash_1.isFinite)(salaryMin) ? salaryFilter.minRange === salaryMin : true;
            const isSalaryRateEqual = salaryFilter.rate === salaryRate || (!salaryFilter.rate && !salaryRate);
            const isSalaryEqual = isSalaryRateEqual && isSalaryMaxEqual && isSalaryMinEqual;
            if (isSubscribed) {
                if (!isSalaryEqual) {
                    if (salaryRate) {
                        setSalaryFilter({
                            minRange: salaryMin,
                            maxRange: salaryMax || roundedHighestSalary,
                            highestSalary: roundedHighestSalary,
                            rate: salaryRate,
                        });
                    }
                    else if (highestGlobalSalary) {
                        setSalaryFilter({
                            minRange: 0,
                            maxRange: highestGlobalSalary,
                            highestSalary: highestGlobalSalary,
                            rate: null,
                        });
                    }
                }
                setPage(initPage);
            }
        };
        getHighestSalaryByRateAndSetValues();
        return () => {
            isSubscribed = false;
        };
    }, [salaryMin, salaryMax, salaryRate]);
    react_1.default.useEffect(() => {
        const roundedHighestSalary = (0, roundSalaryToTen_1.roundSalary)(highestSalary);
        if (roundedHighestSalary !== salaryFilter.highestSalary) {
            setWasHighestSalaryChangedFromHook(true);
            if (salaryRate) {
                setSalaryFilter({
                    minRange: salaryMin,
                    maxRange: salaryMax || roundedHighestSalary,
                    highestSalary: roundedHighestSalary,
                    rate: salaryRate,
                });
            }
            else if (highestSalary) {
                setSalaryFilter({
                    minRange: 0,
                    maxRange: roundedHighestSalary,
                    highestSalary: roundedHighestSalary,
                    rate: null,
                });
            }
        }
    }, [highestSalary]);
    react_1.default.useEffect(() => {
        const areCompaniesEqual = (0, lodash_1.isEqual)(searchCompaniesSelected.map(({ id }) => id), selectedCompaniesIds);
        if (!areCompaniesEqual) {
            refetchCompanies();
        }
    }, [selectedCompaniesIds]);
    react_1.default.useEffect(() => {
        if (companies && !(0, lodash_1.isEqual)(companies, searchCompaniesSelected) && selectedCompaniesIds.length) {
            setSearchCompaniesSelected(companies);
        }
        else if (!selectedCompaniesIds.length && (companies === null || companies === void 0 ? void 0 : companies.length)) {
            refetchCompanies();
            setSearchCompaniesSelected([]);
        }
    }, [companies]);
    react_1.default.useEffect(() => {
        if (globalHighestSalary) {
            setHighestGlobalSalary((0, roundSalaryToTen_1.roundSalary)(globalHighestSalary));
        }
    }, [globalHighestSalary]);
    const { data: offers, isLoading: areOffersLoading, error: offersError, } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.offers.key, {
        [types_1.OfferFilterType.type]: typeFiltersSelected,
        [types_1.OfferFilterType.location]: locationFiltersSelected,
        [types_1.OfferFilterType.jobArea]: jobAreaFiltersSelected,
        [types_1.OfferFilterType.salaryMin]: salaryFilter.minRange,
        [types_1.OfferFilterType.salaryMax]: salaryFilter.maxRange,
        [types_1.OfferFilterType.salaryRate]: salaryFilter.rate,
        [types_1.OfferFilterType.searchCompaniesSelected]: searchCompaniesSelected.map(({ id: companyId }) => companyId),
        [types_1.OfferFilterType.searchKeywordsSelected]: searchKeywordsSelected,
        page,
    }, [
        typeFiltersSelected,
        locationFiltersSelected,
        jobAreaFiltersSelected,
        salaryFilter,
        searchCompaniesSelected,
        searchKeywordsSelected,
        page,
    ]);
    const { data: offersFiltersSSR, isLoading: areFiltersLoading, error: filterError, } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.offersFilters.key, {
        [types_1.OfferFilterType.type]: typeFiltersSelected,
        [types_1.OfferFilterType.location]: locationFiltersSelected,
        [types_1.OfferFilterType.jobArea]: jobAreaFiltersSelected,
        [types_1.OfferFilterType.salaryMin]: salaryFilter.minRange,
        [types_1.OfferFilterType.salaryMax]: salaryFilter.maxRange,
        [types_1.OfferFilterType.salaryRate]: salaryFilter.rate,
        [types_1.OfferFilterType.searchCompaniesSelected]: searchCompaniesSelected.map(({ id: companyId }) => companyId),
        [types_1.OfferFilterType.searchKeywordsSelected]: searchKeywordsSelected,
        page,
    }, [
        typeFiltersSelected,
        locationFiltersSelected,
        jobAreaFiltersSelected,
        salaryFilter,
        searchCompaniesSelected,
        searchKeywordsSelected,
        page,
    ]);
    const { data: promotedOffers, isLoading: arePromotedOffersLoading, error: promotedOffersError, } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.promotedOffers.key, {
        [types_1.OfferFilterType.type]: typeFiltersSelected,
        [types_1.OfferFilterType.location]: locationFiltersSelected,
        [types_1.OfferFilterType.jobArea]: jobAreaFiltersSelected,
        [types_1.OfferFilterType.salaryMin]: salaryFilter.minRange,
        [types_1.OfferFilterType.salaryMax]: salaryFilter.maxRange,
        [types_1.OfferFilterType.salaryRate]: salaryFilter.rate,
        [types_1.OfferFilterType.searchCompaniesSelected]: searchCompaniesSelected.map(({ id: companyId }) => companyId),
        [types_1.OfferFilterType.searchKeywordsSelected]: searchKeywordsSelected,
    }, [
        typeFiltersSelected,
        locationFiltersSelected,
        jobAreaFiltersSelected,
        salaryFilter,
        searchCompaniesSelected,
        searchKeywordsSelected,
    ]);
    react_1.default.useEffect(() => {
        if (filterError || offersError || promotedOffersError) {
            // @ts-ignore
            history.pushLocalized('/error');
        }
    }, [filterError, offersError]);
    react_1.default.useEffect(() => {
        return () => {
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.companies.key);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.highestSalary.key);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.globalHighestSalary.key);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.offers.key);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.offersFilters.key);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.promotedOffers.key);
        };
    }, []);
    return {
        OffersFilterContextProvider: OffersFilterContext.Provider,
        value: {
            typeFiltersSelected,
            locationFiltersSelected,
            jobAreaFiltersSelected,
            searchCompaniesSelected,
            searchKeywordsSelected,
            setTypeFiltersSelected: id => setTypeFiltersSelected(id),
            setLocationFiltersSelected: loc => setLocationFiltersSelected(loc),
            setJobAreaFiltersSelected: id => setJobAreaFiltersSelected(id),
            setSearchCompaniesSelected: comps => setSearchCompaniesSelected(comps),
            setSearchKeywordsSelected: keywords => setSearchKeywordsSelected(keywords),
            offers,
            promotedOffers,
            offersFiltersSSR,
            areOffersLoading,
            areFiltersLoading,
            arePromotedOffersLoading,
            changePage: n => changePage(n),
            setPage: p => setPage(p),
            salaryFilter,
            setSalaryFilter: f => setSalaryFilter(f),
            highestSalary: highestSalary || 0,
            getHighestSalary,
            isFilterActive,
            companies,
            highestGlobalSalary,
        },
    };
};
exports.useOffersFilterContextProvider = useOffersFilterContextProvider;
const useOffersFilterContextValue = () => {
    const context = react_1.default.useContext(OffersFilterContext);
    return context;
};
exports.useOffersFilterContextValue = useOffersFilterContextValue;
